import Vue from 'vue';
import {
  Product,
  ProductStatus
} from '@/lib/utilities/enums';
import {
  HelperFunctions
} from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    ProductAccountSearchResults: [],
    ActivePlatforms: [],
    ProductsList: [],
    ProductStatus: [],
    Products: [],
    CurrentProductDetails: {},
    showEditProductModal: false,
    //SalesRepList: [],
    //DealershipUsers: [],
    RemainingProducts: [],
    ModalAccountSearchResults: [],
    ModalActivePlatforms: [],
    showAddProductModal: false,
    ModalSalesRepList: [],
    ModalDealershipUsers: [],
    ProductFeatures: []
  }
}

const state = initialState();

const actions = {

  PA_searchAccounts: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly + '&activeOnly=' + param.activeOnly).then(function (data) {
        //console.log("results : ", data);
        context.commit('updateSearchResults', data.data.Data);
        data.data.Data.forEach(function (account) {
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadDealersForAccount: function (context, param) {
    var query;
    if (param.allDealers) {
      query = 'account/allplatforms/' + param.accountId;
    } else {
      query = 'account/platforms/' + param.accountId;
    }
    return new Promise((resolve, reject) => {
      Vue.http.get(query).then(function (data) {
        context.commit('updatePlatforms', data.data.Data.sort(HelperFunctions.sortByProperty('Name')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  filterProducts: function (context, query) {
    if (query == null)
      reject(error);
    return new Promise((resolve, reject) => {
      Vue.http.post('products', query).then(function (data) {
        if (data.data && data.data.Data) {
          context.commit('updateProducts', data.data);
          resolve(data.data);
        } else
          reject(data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  exportProductAdminList: function (context, query) {
    let params = {
      AccountId: query.params.AccountId,
      PlatformIds: query.params.PlatformIds,
      ProductIds: query.params.ProductIds,
      ProductStatus: query.params.ProductStatus,
      FeatureId: query.params.FeatureId,
      FeatureStatus: query.params.FeatureStatus,
      From: 0,
      Size: 100,
      SortBy: "account"
    };
    return new Promise((resolve, reject) => {
      Vue.http
        .post("exportProductsToCSV" , params)
        .then(function (response) {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editProduct: function (context, productId) {
    if (productId == null)
      return null;

    return new Promise((resolve, reject) => {
      Vue.http.get('product/' + productId).then(function (data) {
      
         if (data && data.data.Data && data.data.Success) {
          let retData = data.data.Data;
          retData.Product.ProductConfigurationURL = retData.ProductConfigurationURL;
          retData.Product.ProductExternallyConfigured = retData.ProductExternallyConfigured;

          context.commit('updateProductDetails', retData.Product);
          // context.commit('updateSalesRep', retData.SalesReps);
          // context.commit('updateDealershipUsers', retData.DealershipUsers);
          resolve(data.data.Data);
        }
        else
        {
          reject(data); 
        }

        
      }).catch((error) => {
        reject(error)
      });
    });
  },
  saveProductDetails: function (context, product) {
    if (product == null)
      reject(error);

    return new Promise((resolve, reject) => {
      Vue.http.post('products/saveproduct', product).then(function (data) {
        if (data.data && data.data.Data) {
          context.commit('productUpdated', data.data.Data);
          resolve(data.data.Data);
        } else
        {
          reject(data);
      }
      }).catch((error) => {
        reject(error)
      });
    });
  },
  searchAccountsForModal: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly + '&activeOnly=' + param.activeOnly).then(function (data) {
        //console.log("results : ", data);
        data.data.Data.forEach(function (account) {
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        context.commit('updateModalSearchResults', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadDealersForModal: function (context, param) {
    var query;
    if (param.allDealers) {
      query = 'account/allplatforms/' + param.accountId;
    } else {
      query = 'account/platforms/' + param.accountId;
    }
    return new Promise((resolve, reject) => {
      Vue.http.get(query).then(function (data) {
        context.commit('updateModalPlatforms', data.data.Data.sort(HelperFunctions.sortByProperty('Name')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadMissingProducts: function (context, params) {
    if (params == null)
      return null;

    return new Promise((resolve, reject) => {
      Vue.http.get('platform/missingproducts/' + params.accountId + '/' + params.platformId).then(function (data) {

        if (data && data.data.Data) {
          var retData = data.data.Data;
          context.commit('updateMissingProducts', retData.MissingProducts);
          // context.commit('updateModalSalesRep', retData.SalesRep.sort(HelperFunctions.sortByProperty('Name')));
          // context.commit('updateModalDealershipUsers', retData.DealershipUsers.sort(HelperFunctions.sortByProperty('FirstName')));
        }

        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadProductListAndFeatures: function (context) {
    return new Promise((resolve, reject) => {
      Vue.http.get('products/getproductlist', true).then(function (data) {

        if (data && data.data.Data) {
          context.commit('updateProductandFeaturesList', data.data.Data);
          resolve(data.data.Data);
        }
        else
          reject(data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadProductStatus: function (context) {
    return new Promise((resolve, reject) => {
      Vue.http.get('products/getstatuslist').then(function (data) {

        if (data && data.data.Data) {
          context.commit('updateProductStatus', data.data.Data);
          resolve(data.data.Data);
        }
        else
          reject(data);
      }).catch((error) => {
        reject(error)
      });
    });
  },

  setModalPlatforms(context, value) {
    context.commit('updateModalPlatforms', value);
  },
  setModalSearchResults(context, value) {
    context.commit('updateModalSearchResults', value);
  },
  setMissingProducts(context, value) {
    context.commit('updateMissingProducts', value);
  },
  // setModalSalesRep(context, value){
  //   context.commit('updateModalSalesRep', value);
  // },
  // setModalDealershipUsers(context, value){
  //   context.commit('updateModalDealershipUsers', value);
  // },
  setToggleAddProductModal(context, value){
    context.commit('toggleAddProductModal', value);
  },
  setToggleEditProductModal(context, value){
    context.commit('toggleEditProductModal', value);
  },
  updateProductDetails(context, value){
    context.commit('updateProductDetails', value);
  }
};

const mutations = {
  updateSearchResults: function (state, data) {
    state.ProductAccountSearchResults = data;
  },
  updatePlatforms: function (state, data) {
    state.ActivePlatforms = data;
  },
  updateProductandFeaturesList: function (state, data) {
    state.ProductsList = data.sort(HelperFunctions.sortByProperty('Name'));;
  },
  updateProductStatus: function (state, data) {
    state.ProductStatus = data;
  },
  productUpdated: function (state, product) {
    // Update the product in the list
    if (product && product.AccountProductID > 0 && state.Products && state.Products.length > 0) {
      let index = state.Products.findIndex(prod => prod.AccountProductID == product.AccountProductID);
      if (index < 0)
        return;

      let oldProduct = state.Products[index];
      // If status has been changed, remove it from the list
      if (oldProduct.ProductStatusID != product.ProductStatusID)
        state.Products.splice(index, 1);
      else // If any other props changed, replace the old record with the new one
      {
        // since these fields are not updated in Edit Section, it is safe to copy it from the old product
        product.DealerWithId = product.AccountPlatform;
        product.URL = oldProduct.URL;
        product.Location = oldProduct.Location;
        state.Products.splice(index, 1, product);
      }

    }
  },
  updateProducts: function (state, data) {
    state.Products = data.Data;
  },
  updateProductDetails: function (state, data) {
    state.CurrentProductDetails = data;
  },
  // updateSalesRep: function (state, data) {
  //   state.SalesRepList = data;
  // },
  // updateDealershipUsers: function (state, data) {
  //   state.DealershipUsers = data;
  // },
  toggleEditProductModal: function (state, data) {
    state.showEditProductModal = data;
  },
  updateModalSearchResults: function (state, data) {
    state.ModalAccountSearchResults = data;
  },
  updateModalPlatforms: function (state, data) {
    state.ModalActivePlatforms = data;
  },
  toggleAddProductModal: function (state, data) {
    state.showAddProductModal = data;
  },
  updateMissingProducts: function (state, data) {
    state.RemainingProducts = data;
  },
  // updateModalSalesRep: function (state, data) {
  //   state.ModalSalesRepList = data;
  // },
  // updateModalDealershipUsers: function (state, data) {
  //   state.ModalDealershipUsers = data;
  // }
};

const getters = {

  ProductAccountSearchResults: function () {
    return state.ProductAccountSearchResults;
  },
  Platforms: function () {
    return state.Platforms;
  },
  ProductsList: function () {
    return state.ProductsList;
  },
  ProductStatus: function () {
    return state.ProductStatus;
  },
  Products: function () {
    return state.Products;
  },
  ProductFeatures: function () {
    return state.ProductFeatures;
  },
  CurrentProductDetails: function () {
    return state.CurrentProductDetails;
  },
  // SalesRepList: function () {
  //   return state.SalesRepList;
  // },
  // DealershipUsers: function () {
  //   return state.DealershipUsers;
  // },
  showEditProductModal: function () {
    return state.showEditProductModal;
  },
  ModalAccountSearchResults: function () {
    return state.ModalAccountSearchResults;
  },
  ModalActivePlatforms: function () {
    return state.ModalActivePlatforms;
  },
  showAddProductModal: function () {
    return state.showAddProductModal;
  },
  RemainingProducts: function () {
    return state.RemainingProducts;
  },
  // ModalDealershipUsers: function () {
  //   return state.ModalDealershipUsers;
  // },
  // ModalSalesRepList: function () {
  //   return state.ModalSalesRepList;
  // }

};

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ProductAdmin.js